import React from "react";
import { useLanguage } from "../LanguageContext";
import { mailtoWithSubject } from "../utils/mailto";

const Footer: React.FC = () => {
    const { t } = useLanguage();
    const f = t.footer;
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-top">
                    <div className="footer-brand">
                        <span className="footer-logo-text">SYSLOGICS</span>
                        <p>{f.tagline}</p>
                    </div>
                    <nav className="footer-nav">
                        <a href="#about">{f.nav.about}</a>
                        <a href="#services">{f.nav.services}</a>
                        <a href="#partners">{f.nav.partners}</a>
                        <a href="#contact">{f.nav.contact}</a>
                    </nav>
                </div>

                <div className="footer-pillars">
                    {f.pillars.map(pillar => (
                        <div className="footer-pillar" key={pillar.title}>
                            <div className="pillar-rule" />
                            <h4>{pillar.title}</h4>
                            <p>{pillar.desc}</p>
                        </div>
                    ))}
                </div>

                <div className="footer-rule" />
                <div className="footer-bottom-content">
                    <span>{f.copy}</span>
                    <span className="footer-tagline-text">{f.taglineBottom}</span>
                    <a href={mailtoWithSubject(t.mail.general)} className="btn-ghost-sm">{f.getStarted}</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
